import { doc, onSnapshot, setDoc, serverTimestamp, getDoc } from "firebase/firestore";
import { db } from "../firebase";

let enabled = true;
let initialized = false;

export function ensureMetricsToggleListener() {
  if (initialized) return;
  initialized = true;
  const ref = doc(db, "appConfig", "dailyReads");
  onSnapshot(ref, (snap) => {
    if (snap.exists()) {
      const data = snap.data() || {};
      enabled = data.enabled !== false; // default true
    } else {
      enabled = true;
    }
  });
}

export function isDailyReadsEnabled() {
  return enabled;
}

export async function setDailyReadsEnabled(value) {
  const ref = doc(db, "appConfig", "dailyReads");
  await setDoc(ref, { enabled: !!value, updatedAt: serverTimestamp() }, { merge: true });
}

export async function fetchDailyReadsEnabledOnce() {
  const ref = doc(db, "appConfig", "dailyReads");
  const snap = await getDoc(ref);
  if (snap.exists()) {
    const data = snap.data() || {};
    return data.enabled !== false;
  }
  return true;
}

